module.exports = "/_next/static/images/e7dbc394d836f729e3ad51a8cc5d1554-wow@1x.png.webp";